import PropTypes from 'prop-types';
import {Component} from 'react';
import {Form, Header, Segment} from 'semantic-ui-react';
import ComparableSummaryContainer from './ComparableSummaryContainer';
import EditableTitle from './EditableTitle';
import FeaturedComparableContainer from './FeaturedComparableContainer';
import {DisclaimerText} from 'components/DisclaimerText';

export default class CustomiseComparableRentals extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    reportType: PropTypes.string.isRequired,
    selectedComparableRentals: PropTypes.arrayOf(PropTypes.number),
    featuredProperties: PropTypes.arrayOf(PropTypes.number),
    updateSectionValue: PropTypes.func.isRequired,
    updatePreferences: PropTypes.func.isRequired,
  };

  render() {
    const {
      section,
      reportType,
      updateSectionValue,
      updatePreferences,
      selectedComparableRentals = [],
      featuredProperties = [],
    } = this.props;

    return (
      <div className="comparable-rentals">
        <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Comparable Rentals</Header>
        <Segment style={{padding: '30px'}}>
          <Header as="h3">
            <span className="disabled">Title</span>
            <DisclaimerText/>
          </Header>
          <Form className="sectionData">
            <Form.Group inline>
              <EditableTitle
                onUpdateData={(data) => {
                  updateSectionValue(data.title, 'title');
                  updatePreferences({'comparableRentals.sectionData.title': data.title}, reportType);
                }}
                width="50%"
                isEnabled={true}
                maxLength={32}
                title={section.sectionData.title}/>
            </Form.Group>
          </Form>
          <div className="featured-rentals">
            {featuredProperties && featuredProperties.filter((id) => id).map(id => (
              <FeaturedComparableContainer propertyId={id} comparableType="rentals" key={id}/>
            ))}
          </div>
          <div className="comparable-rentals">
            {selectedComparableRentals && selectedComparableRentals.filter((id) => id).map(id => (
              <ComparableSummaryContainer propertyId={id} pageContext="Comparable Rentals" key={id}/>
            ))}
          </div>
        </Segment>
      </div>
    );
  }
}
